import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { createApiKey, listGrants, listSubaccountGrants } from 'src/actions/api-keys';
import { showAlert } from 'src/actions/globalAlert';
import { getFormLoading } from 'src/selectors/api-keys';

import ApiKeyForm from './components/ApiKeyForm';
import { Loading } from 'src/components';
import { PageLink } from 'src/components/links';
import { Page, Panel } from 'src/components/matchbox';
import { RUDDERSTACK_EVENTS } from 'src/helpers/rudderstack';
import track from 'src/helpers/track';

const breadcrumbAction = {
  content: 'API Keys',
  Component: PageLink,
  to: '/account/api-keys'
};

export class CreatePage extends React.Component {
  componentDidMount() {
    this.props.listGrants();
    if (this.props.hasSubaccounts) {
      this.props.listSubaccountGrants();
    }
  }

  onSubmit = (values) => {
    const { createApiKey, history, showAlert } = this.props;

    return createApiKey(values).then(() => {
      showAlert({ type: 'success', message: 'API key created' });
      history.push('/account/api-keys');
      track(RUDDERSTACK_EVENTS.API_KEY_CREATED);
    });
  };

  render() {
    if (this.props.loading) {
      return <Loading />;
    }

    return (
      <Page title="Create API Key" breadcrumbAction={breadcrumbAction}>
        <Panel.LEGACY>
          <ApiKeyForm onSubmit={this.onSubmit} isReadOnly={false} />
        </Panel.LEGACY>
      </Page>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: getFormLoading(state),
  hasSubaccounts: state.subaccounts.total > 0
});

export default withRouter(
  connect(mapStateToProps, { createApiKey, listGrants, listSubaccountGrants, showAlert })(
    CreatePage
  )
);
